/* eslint-disable */
import React, {
	createContext,
	useContext,
	useEffect,
	useMemo,
	useState,
} from "react";
import { getCurrentUser } from "../services/user";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const [token, setToken] = useState(localStorage.getItem("token"));
	const [userInfo, setUserInfo] = useState(null);

	const setNewToken = (newToken) => {
		setToken(newToken);
		localStorage.setItem("token", token);
	};

	useEffect(() => {
		console.log("AuthProvider mounted");
		return () => console.log("AuthProvider unmounted");
	}, []);

	const getUserInfo = async () => {
		try {
			const res = await getCurrentUser();
			console.log("getUserInfo: ", res);
			if (res) {
				setUserInfo(res);
			}
		} catch (e) {
			console.log(e);
		}
	};

	useEffect(() => {
		if (token) {
			localStorage.setItem("token", token);
			// 获取用户详细信息
			getUserInfo();
		} else {
			// localStorage.removeItem("token");
			localStorage?.clear();
		}
	}, [token]);

	const contextValue = useMemo(
		() => ({
			token,
			setNewToken,
			userInfo,
			setUserInfo,
		}),
		[token, userInfo]
	);

	return (
		<AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
	);
};

export const useAuth = () => {
	return useContext(AuthContext);
};

export default AuthProvider;
